module.exports = "https://www.gc-qa.gnp.com.mx/d609515d0a25d2050f03f62e96e15d17.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/equis-circulo.svg
// module id = 8102
// module chunks = 0